export enum BookingStep {
  BOOKING_FORM = 'BOOKING_FORM',
  OPTIONAL_EXTRAS = 'OPTIONAL_EXTRAS',
}
